var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './ControlsModalContent.module.scss';
import classNames from 'classnames';
import { ControlItem, } from 'src/ui/views/dynamics/CaseGlobalViewPage/components/documents/ControlItem/ControlItem';
import { ControlsModalPlaceholder } from 'src/ui/views/dynamics/CaseGlobalViewPage/components/modals/ControlsModal/ControlsModalPlaceholder/ControlsModalPlaceholder';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
export var ControlsModalContent = function (props) {
    var i18n = props.i18n, controls = props.controls, className = props.className, onResetFilter = props.onResetFilter;
    if (controls.length < 1) {
        return _jsx(ControlsModalPlaceholder, { i18n: i18n, onResetFilters: onResetFilter, className: className });
    }
    var numberOfControls = controls.length;
    var controlLabelKeyPath = numberOfControls === 1 ? 'common.control' : 'common.controls';
    var controlLabel = getPropsByKeyPath(i18n.keyValueMap, controlLabelKeyPath);
    var numberOfControlsLabel = "".concat(numberOfControls, " ").concat(controlLabel);
    var contentClass = classNames(className);
    return (_jsxs("div", __assign({ className: contentClass }, { children: [_jsx("h3", __assign({ className: styles.controlsModalControlsWrapperTitle }, { children: numberOfControlsLabel })), _jsx("div", { children: controls.map(function (control, index) { return (_jsx(ControlItem, __assign({}, control), "".concat(control.description, "-").concat(index))); }) })] })));
};
